



























import { Vue, Prop, Component } from "vue-property-decorator"
import { formatDate } from "@/services/DurationFormatter"
import { EventBus } from "@/event-bus"
import "@/assets/plyr.css"
import { AwEventType } from "@/models/AwEventType"
import { AnalyticsClient } from "@/services/AnalyticsService"
import { container } from "tsyringe"
@Component
export default class IframeVideoPlayer extends Vue {
  @Prop({ required: true }) public iframe_url!: string
  @Prop({ required: true }) public poster!: string
  @Prop({ required: true }) public duration!: string
  @Prop({ default: false }) public isgated!: boolean
  @Prop({ default: -1 }) private mid!: number
  get isGated(): boolean {
    return this.isgated && this.$root.$data.isGated
  }
  private durWidth = 20
  private dur = formatDate(this.duration)
  private height = "100%"
  private isposter = true
  private loaded = false
  init() {
    this.height = `${this.$el.clientWidth / 1.77}px`
    this.durWidth = (this.$refs.duration as HTMLElement).clientWidth
  }

  mounted() {
    this.init()
    EventBus.$on("carouselSetupCompleted", this.init)
  }

  clickPoster() {
    if (this.isGated) {
      this.clickGate()
    } else {
      EventBus.$emit("playing-iframe-Video", this.mid)
      this.isposter = false
      this.loaded = true
    }
  }
  clickGate() {
    EventBus.$emit("gate-event")
    var event = { eventType: AwEventType.GateClicked }
    const _analytics = container.resolve(AnalyticsClient)
    _analytics.register(event, this.$root.$data.identifierKey)
  }
}
